"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Server = void 0;
const JSONWriter_1 = require("lincd-jsonld/lib/utils/JSONWriter");
const JSONParser_1 = require("lincd-jsonld/lib/utils/JSONParser");
const lincd_1 = require("lincd/lib/ontologies/lincd");
const npm_1 = require("lincd/lib/ontologies/npm");
class Server {
    /**
     * Call a method on the server for this specific shape.
     * See the documentation on `Providers` to learn more about implementing server side methods for shapes.
     * @param shape
     * @param method
     * @param args
     */
    static call(shape, method, ...args) {
        return __awaiter(this, void 0, void 0, function* () {
            //SHACL Shapes are generated by using @linkedShape.
            //They are given a unique but deterministic temporary URI
            //We send that URI over to the server, which will have generated the same URI and thus recognise the shape
            let shapeClass = Object.getPrototypeOf(shape).constructor;
            let SHACL_Shape = shapeClass.shape;
            //get the shape class that defines this shape
            let shapeClassNode = SHACL_Shape.getOneInverse(lincd_1.lincd.definesShape);
            //get the module that exports this shape class
            let moduleNode = shapeClassNode.getOne(lincd_1.lincd.module);
            let moduleName = moduleNode.getValue(npm_1.npm.packageName);
            let body = yield JSONWriter_1.JSONWriter.stringify({
                shapeURI: SHACL_Shape.namedNode.uri,
                instanceNode: shape.node,
                args
            }, true);
            return fetch(`${process.env.SITE_ROOT}/call/${moduleName}/${shapeClass.name}/${method}`, {
                method: 'POST',
                headers: {
                    Accept: 'application/json, text/plain, */*',
                    'Content-Type': 'application/json',
                },
                body
            }).then(res => {
                if (res.ok) {
                    return res.json();
                }
                else {
                    console.warn("Could not complete server call: " + res.statusText);
                }
            }).then(json => {
                return JSONParser_1.JSONParser.parseObject(json);
            }).catch(err => {
                console.warn("Error during server call: ", err);
            });
        });
    }
}
exports.Server = Server;
//# sourceMappingURL=Server.js.map